const emptyToNull = <T extends Record<string, unknown>>(obj: Partial<T>) => {
    for (const prop in obj) {
        if (typeof obj[prop] === 'string' && obj[prop] === '') {
            obj[prop] = null!;
        }
    }
    return obj;
};
export default emptyToNull;
